import styled, { css } from "styled-components";
import {
  Avatar as MuiAvatar,
  Button as MuiButton, Divider as MuiDivider,
  MenuItem as MuiMenuItem,
  MenuList as MuiMenuList,
} from "@material-ui/core";

export const ProfileButton = styled(MuiButton)`
  padding-right: ${props => props.theme.widthRatio*props.theme.spacing(2.5)}px;
  padding-left: ${props => props.theme.widthRatio*props.theme.spacing(2.5)}px;
  
  &:hover {
    background: ${props => props.theme.palette.third["10"]};
  }
  
  .arrow-down {
  	width: ${props => props.theme.widthRatio*18}px;
  	height: ${props => props.theme.heightRatio*11}px;
  }
`;

export const MenuList = styled(MuiMenuList)`
  position: absolute;
  top: ${props => props.theme.heightRatio*120}px;
  right: ${props => props.theme.widthRatio*50}px;
  background: ${props => props.theme.palette.primary.main};
  border-radius: ${props => props.theme.widthRatio*5}px;
  padding-top: ${props => props.theme.heightRatio*props.theme.spacing(4)}px;
  padding-bottom: ${props => props.theme.heightRatio*props.theme.spacing(4)}px;
  z-index: 2;
  
  ${props => props.theme.name === 'dark' && css`
    border: 1px solid ${props => props.theme.palette.secondary.main};
  `}
  
  ${props => props.theme.name === 'light' && css`
    box-shadow: 0 2px 32px 4px rgba(0,0,0,0.2);
  `}
  
  .menu-item {
  	display: flex;
  	align-items: center;
  	justify-content: space-between;
  	padding: ${props => props.theme.heightRatio*props.theme.spacing(2.5)}px
  	 				 ${props => props.theme.widthRatio*props.theme.spacing(7.5)}px;
  	 				 
  	 img {
  	 	&:first-of-type {
  	 		width: ${props => props.theme.widthRatio*20}px;
  	 		height: ${props => props.theme.widthRatio*20}px;
  	 	}
  	 	&:nth-of-type(2) {
				width: ${props => props.theme.widthRatio*23.5};
				height: ${props => props.theme.heightRatio*23.5}px;
  	 	}
  	}
  }
  
  .footer {
    display: flex;
    justify-content: center;
  }
`;

export const LogOutButton = styled(MuiButton)`
  font: ${props => props.theme.widthRatio * 22}px/${props => props.theme.heightRatio * 30}px SFProRounded-Regular;
  color: ${props => props.theme.palette.third["100"]};
  border: 1px solid ${props => props.theme.palette.third[100]};
  border-radius: 4px;
  padding: ${props => props.theme.heightRatio*10}px
           ${props => props.theme.widthRatio*17}px;
  display: flex;
  align-items: center;
  
  img {
    width: ${props => props.theme.widthRatio*24}px;
    height: ${props => props.theme.heightRatio*24}px;
    margin-right: ${props => props.theme.widthRatio*15}px;
  }
`;

export const MenuItem = styled(MuiMenuItem)`
  font: ${props => props.theme.widthRatio*22}px/30px SFProRounded-Regular;
  color: ${props => props.theme.palette.third["100"]};
  padding-left: ${props => props.theme.widthRatio*props.theme.spacing(7.5)}px;
  padding-right: ${props => props.theme.widthRatio*props.theme.spacing(7.5)}px;
  min-height: unset;
  justify-content: center;
  
  img {
    width: ${props => props.theme.widthRatio*24}px;
    height: ${props => props.theme.heightRatio*24}px;
    margin-right: ${props => props.theme.widthRatio*15}px;
  }
  
  .name {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    
    p {
      font: ${props => props.theme.widthRatio*21}px/28px SFProRounded-Bold;
      color: ${props => props.theme.palette.third[100]};
      margin: 0 !important;
      text-align: center;
    }
  
    span {
      font: ${props => props.theme.widthRatio*21}px/28px SFProRounded-Regular;
      color: ${props => props.theme.palette.third[100]}60;
      text-align: center;
    }
  }
`;

export const Profile = styled.div`
  display: inline-flex;
  flex-flow: column;
  justify-content: flex-start;
  margin-right: ${props => props.theme.widthRatio*17}px;
  
  h5 {
    font: ${props => props.theme.widthRatio*24}px/${props => props.theme.heightRatio*32}px SFProRounded-Regular;
  }
  
  p {
    color: ${props => props.theme.palette.third["50"]};
    font: ${props => props.theme.widthRatio*18}px/${props => props.theme.heightRatio*24}px SFProRounded-Regular;
  }
`;

export const Avatar = styled(MuiAvatar)`
  display: inline-flex;
  margin-right: ${props => props.theme.widthRatio*19}px;
  width: ${props => props.theme.widthRatio * 60}px;
  height: ${props => props.theme.widthRatio * 60}px;
  
  ${props => props.theme.name === 'dark' && css`
    opacity: 0.5;
  `}
`;

export const Divider = styled(MuiDivider)`
  flex: 1;
	background-color: ${props => props.theme.name === 'dark' ? '#FFBD5950' : '#1F1F1F50'};
	margin: ${props => props.theme.heightRatio * 11}px
	 				${props => props.theme.widthRatio * 13}px
	 				${props => props.theme.heightRatio * 13}px
	 				${props => props.theme.widthRatio * 13}px;
`;
